import theme from '@styles/theme';
export default {
  section: {
    margin: ['0', '0', '0', '0', '0 0 0 40px'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['space-around', 'space-between'],
    alignItems: 'center',
    flexWrap: 'no-wrap',
    position: 'relative'
  },
  sectionSingleImg: {
    pb: [48, 48, 64, 64, 116],
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: ['hidden', 'auto', 'auto']
  },
  sliderContainer: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    '.swiper': {
      paddingBottom: [80, 80, 96, 156],
      position: 'relative',
      '.swiper-slide': {
        width: 'auto'
      },
      '.swiper-scrollbar': {
        margin: [`32px 0px 48px 24px`, `32px 0px 48px  24px`, `32px 0px 64px  24px`, '40px 10.15625vw 116px 10.15625vw'],
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: [`calc(100% - 48px)`, `calc(100% -  48px)`, `calc(100% - 48px)`, 'calc(100% - (10.15625vw * 2))'],
        height: '2px',
        background: '#cccccc',
        borderRadius: '1px',
        order: 99
      },
      '.swiper-scrollbar-drag': {
        backgroundColor: theme.rawColors.darkGrey700,
        cursor: 'pointer'
      }
    }
  },
  sliderImgStyles: {
    position: 'relative',
    cursor: ['default', 'default', 'pointer'],
    width: 'auto',
    height: '100%',
    border: 'none',
    img: {
      position: 'relative !important',
      width: 'auto !important',
      height: ['calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 174px) !important']
    }
  },
  progressBarContainer: {
    padding: ['32px 16px', '32px 16px', '32px 24px', '32px 24px', '40px 40px 40px 0'],
    width: '100%'
  },
  twoImgGalleryContainer: {
    margin: '0 auto',
    display: 'flex'
  },
  imgContainer: {
    position: 'relative',
    height: '100%',
    border: 'none',
    img: {
      position: 'relative !important',
      width: 'auto !important',
      height: ['calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 154px) !important', 'calc(100vh - 174px) !important']
    },
    margin: '0',
    flexShrink: 0,
    cursor: ['default', 'default', 'pointer']
  },
  twoImgContainer: {
    position: 'relative',
    height: '100%',
    img: {
      position: 'relative',
      width: 'auto',
      height: '100%',
      objectFit: 'contain'
    },
    margin: '0 12px',
    flexShrink: 0,
    cursor: ['default', 'default', 'pointer']
  },
  noJsGallery: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%'
  }
};